import type { SendMfaLoginEmailCodeRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export function useSendMfaLoginEmailCode() {
  return useApiMutation("post", "/auth/mfa/email/send", {
    notify: false,
    mapVariables: (body: SendMfaLoginEmailCodeRequestDto) => ({
      body,
      headers: {
        "x-auth-request": "true",
      },
    }),
  });
}
